module.exports = __webpack_public_path__ + "static/GrayGminaBedzino-fe698efea367e69147763cca603df94e.svg";